import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Badge from 'react-bootstrap/Badge';

import Link from '../../Link/Link';
import Loader from '../../Common/Loader/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import submit from './submit';
import validate from './validate';
import messages from '../../../locale/messages';
import uploadProfileImage from '../../../actions/siteadmin/uploadProfileImage';
import uploadIdentity from '../../../actions/siteadmin/Document/uploadIdentity';
import { removeExperience, uploadExperience } from '../../../actions/siteadmin/Document/uploadExperience';
import { api, profilePhotouploadDir, documentUploadDir, categoryUploadDir } from '../../../config';
import { demoRestriction } from '../../../actions/demoRestriction';

import defaultIcon from '/public/Icons/defaultImage.svg';
import deleteIcon from '/public/Icons/deleteIocn.svg';

import { EditFareIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';
import bt from '../../../components/commonStyle.css';
import s from './EditPartnerForm.css'

export class EditPartnerForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			countryCode: 'IN',
			country: '+91'
		}
	}

	static defaultProps = {
		loading: false
	};

	componentDidMount() {
		const { initialValues, initialize } = this.props;
		if (initialValues && initialValues?.country && initialValues?.phoneCountryCode) {
			this.setState({
				countryCode: initialValues?.phoneCountryCode,
				country: initialValues?.country
			});
		}
	}

	successProfile = async (file, fromServer) => {
		const { change, uploadProfileImage, id, picture, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('picture', fromServer && fromServer.fileName);
		await uploadProfileImage(id, fromServer && fromServer.fileName, picture);
	}

	successIdentity = async (file, fromServer) => {
		const { uploadIdentity, id, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await uploadIdentity(id, fromServer && fromServer.fileName);
	}

	successExperience = async (file, fromServer) => {
		const { uploadExperience, id, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await uploadExperience(id, fromServer && fromServer.fileName);
	}

	handleChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	}

	handleCountryChange = (e, selectedData) => {
		this.setState({
			country: selectedData.dialCode,
			countryCode: selectedData.countryCode
		});
	}


	render() {
		const { handleSubmit, id, picture, loading, submitting, getUser, identityDocument, experienceDocument, removeExperience, userIdentityLoading, currency, phoneDialCode, userExperienceLoading } = this.props
		const { providerImageUploader } = this.props;
		const { formatMessage } = this.props.intl;
		const { profileId, services } = this.props;
		const permitBanOptions = [
			{ value: "0", label: formatMessage(messages.permit) },
			{ value: "1", label: formatMessage(messages.ban) }
		]
		const partnerStatus = [
			{ value: "pending", label: formatMessage(messages.pending) },
			{ value: "active", label: formatMessage(messages.approve) },
			{ value: "inactive", label: formatMessage(messages.decline) }
		]
		const currencyOptions = currency && currency?.availableCurrencies?.filter(item => item?.isEnable).map(item => {
			return {
				value: item?.symbol,
				label: item?.symbol
			}
		})
		return (
			<>
				<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
					<div className={cx(s.badgeWrapperFlex, 'siteAdminPrimaryHeading')}>
						<span>{formatMessage(messages.editPartner)}</span>
						<div className={s.userStatusBadge}>
							<Badge pill variant={getUser && getUser.result && getUser.result.isActive === 1 && getUser.result.isBan === 0 ? 'success' : 'danger'}>
								{getUser && getUser.result && getUser.result.isActive === 1 && getUser.result.isBan === 0 ? formatMessage(messages.online) : formatMessage(messages.offline)}
							</Badge>
							{' '}
							{getUser && getUser.result && getUser.result.isActive === 1 && getUser.result.isBan === 0 && <Badge pill variant={getUser.result.activeStatus === "inactive" ? 'success' : 'danger'}>
								{getUser.result.activeStatus === "inactive" ? formatMessage(messages.eligibleForAService) : formatMessage(messages.notEligibleForAService)}
							</Badge>}
						</div>
					</div>
					<div className={cx(s.profileImgSection, s.singleCard)}>
						<label className={bt.commonLabelText} >{formatMessage(messages.profilePicture)}</label><br />
						<div className="commonImageDisplayLoader">

							<Loader
								show={providerImageUploader}
								type={"page"}
							>
								{
									picture &&
									<div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + profilePhotouploadDir}medium_${picture})` }} />
								}
								{
									!picture &&
									<div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
								}
							</Loader>

						</div>

						<ImageUploadComponent
							className='commonSiteAdminDropzoneSpace'
							subText={formatMessage(messages.maximumUploadSizeLabel)}
							defaultMessage={formatMessage(messages.chooseFile)}
							componentConfig={{
								iconFiletypes: ['.jpg', '.png', '.svg'],
								multiple: false,
								showFiletypeIcon: false,
								postUrl: api.apiEndpoint + '/uploadProfileImage'
							}}
							success={this.successProfile}
							loaderName={"providerImageUploader"}
						/>
					</div>
					<Row>
						<Col lg={6} md={6} sm={12} xs={12} className={cx(bt.space4, bt.spaceTop4)}>
							<div className={cx(s.profileImgSection)}>
								<label className={bt.commonLabelText} >{formatMessage(messages.userIdentity)}</label><br />
								<div className="commonImageDisplayLoader">
									<Loader
										show={userIdentityLoading}
										type={"page"}
									>
										{
											identityDocument && identityDocument.length === 0 &&
											<div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
										}
										<div className={cx('row')}>
											{
												identityDocument && identityDocument.length > 0 && identityDocument.map((item, key) => {
													return (
														<div className={s.positionRelative}>
															<Col lg={12} md={12} sm={12} xs={12}>
																<div className={s.bannerImageBg} style={{ backgroundImage: `url(${api.apiEndpoint + documentUploadDir}medium_${item.imageName})` }} />
																<a href="javascript:void(0);" onClick={() => removeExperience(id, item.imageName, 'identityDocument')} className={cx(s.bannerDelete, 'trashIconNewRTL', 'svgImg')}>
																	<img src={deleteIcon} alt='Delete' />
																</a>
															</Col>
														</div>

													);
												})
											}
										</div>
									</Loader>
								</div>
								<ImageUploadComponent
									className='commonSiteAdminDropzoneSpace'
									subText={formatMessage(messages.maximumUploadSizeLabel)}
									defaultMessage={formatMessage(messages.chooseFile)}
									componentConfig={{
										iconFiletypes: ['.jpg', '.png', '.svg'],
										multiple: false,
										showFiletypeIcon: false,
										postUrl: api.apiEndpoint + '/uploadIdentityImage'
									}}
									success={this.successIdentity}
									loaderName={"userIdentityLoading"}
								/>
							</div>
						</Col>
						<Col lg={6} md={6} sm={12} xs={12} className={cx(bt.space4, bt.spaceTop4)}>
							<div className={cx(s.profileImgSection)}>
								<label className={bt.commonLabelText} >{formatMessage(messages.userExperience)}</label><br />
								<div className="commonImageDisplayLoader">
									<Loader show={userExperienceLoading} type={"page"}>
										{
											experienceDocument && experienceDocument.length === 0 &&
											<div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
										}
										<div className={cx('row')}>
											{
												experienceDocument && experienceDocument.length > 0 && experienceDocument.map((item, key) => {
													return (

														<div className={s.positionRelative}>
															<Col lg={12} md={12} sm={12} xs={12}>
																<div className={s.bannerImageBg} style={{ backgroundImage: `url(${api.apiEndpoint + documentUploadDir}medium_${item.imageName})` }} />
																<a href="javascript:void(0);" onClick={() => removeExperience(id, item.imageName, 'experienceDocument')} className={cx(s.bannerDelete, 'trashIconNewRTL', 'svgImg')}>
																	<img src={deleteIcon} alt='Delete' />
																</a>
															</Col>
														</div>

													);
												})
											}
										</div>
									</Loader>
								</div>

								<ImageUploadComponent
									className='commonSiteAdminDropzoneSpace'
									subText={formatMessage(messages.maximumUploadSizeLabel)}
									defaultMessage={formatMessage(messages.chooseFile)}
									componentConfig={{
										iconFiletypes: ['.jpg', '.png', '.svg'],
										multiple: false,
										showFiletypeIcon: false,
										postUrl: api.apiEndpoint + '/uploadExperienceImage'
									}}
									success={this.successExperience}
									loaderName={"userExperienceLoading"}
								/>
							</div>
						</Col>
					</Row>
					<div className='twoColumnGrid'>
						<Field
							name="firstName"
							type="text"
							placeholder={formatMessage(messages.firstName)}
							component={InputFieldComponent}
							label={formatMessage(messages.firstName)}
							inputClass={bt.formControlInput}
						/>
						<Field
							name="lastName"
							type="text"
							placeholder={formatMessage(messages.lastName)}
							component={InputFieldComponent}
							label={formatMessage(messages.lastName)}
							inputClass={bt.formControlInput}
						/>
						<Field
							name="phoneNumber"
							type="text"
							label={formatMessage(messages.phoneNumber)}
							placeholder={formatMessage(messages.phoneNumber)}
							component={InputFieldComponent}
							isAddon
							prefixLabel={phoneDialCode}
							disabled={true} />
						<Field
							name="email"
							type="text"
							component={InputFieldComponent}
							placeholder={formatMessage(messages.email)}
							label={formatMessage(messages.email)}
							inputClass={bt.formControlInput}
							disabled={true}
						/>
					</div>

					<div className={cx('threeColumnGrid', bt.spaceTop3)}>
						<Field
							name="userStatus"
							component={SelectFieldComponent}
							options={partnerStatus}
							label={formatMessage(messages.userStatus)}
							inputClass={bt.formControlSelect}
						/>
						<Field
							name="isBan"
							label={formatMessage(messages.banStatus)}
							component={SelectFieldComponent}
							options={permitBanOptions}
							inputClass={bt.formControlSelect}

						/>
						<Field
							name='preferredCurrency'
							label={formatMessage(messages.preferredCurrency)}
							component={SelectFieldComponent}
							options={currencyOptions}
							inputClass={bt.formControlSelect}
						/>
					</div>
					<div className={bt.sectionDividerBorder} />
					{
						services.getUserCategory?.length > 0 &&
						<div>
							<div className={s.editServiceProviderListTitle}>{formatMessage(messages.serviceLabel)}</div>
							<div className={s.editServiceProviderListCardContainer}>
								{[...new Map(services.getUserCategory.map(item => [item.mainCategoryId, item])).values()].map((item) => (
									<Link to={`/siteadmin/partners/sub-category/${profileId}/${item.mainCategoryId}`} key={item.mainCategoryId} className={s.editServiceProviderListCardItem}>
										<span className={s.editServiceProviderListCardImgBox}>
											<img
												src={`${api.apiEndpoint}${categoryUploadDir}small_${item.category.logoImage}`}
												height={50}
												width={50}
												alt={item.category.name}
												className={s.editServiceProviderListCardImg}
											/>
										</span>
										{item.category.name}
									</Link>
								))}
							</div>
						</div>
					}
					<div className={s.editServiceProviderListLinkContainer}>
						<Link to={'/siteadmin/partners/category/' + profileId} className={s.editServiceProviderListLink}>
							<EditFareIcon />
							{formatMessage(messages.manageServices)}
						</Link>
					</div>
					<div className={s.editServiceProviderBtnGrp}>
						<Link to={"/siteadmin/partners"} className={bt.btnSecondary}>{formatMessage(messages.goBack)}</Link>
						<Loader
							type={"button"}
							label={formatMessage(messages.update)}
							show={loading}
							buttonType={'submit'}
							className={cx(s.button, bt.btnPrimary)}
							disabled={submitting || loading}
						/>
					</div>
				</Form>
			</>
		)
	}
}

EditPartnerForm = reduxForm({
	form: 'EditPartnerForm', // a unique name for this form
	validate,
	onSubmit: submit
})(EditPartnerForm);

const selector = formValueSelector('EditPartnerForm');

const mapState = state => ({
	id: selector(state, 'id'),
	picture: selector(state, 'picture'),
	phoneDialCode: selector(state, 'phoneDialCode'),
	identityDocument: selector(state, 'identityDocument'),
	experienceDocument: selector(state, 'experienceDocument'),
	loading: state?.loader?.EditProvider,
	userIdentityLoading: state?.loader?.userIdentityLoading,
	userExperienceLoading: state?.loader?.userExperienceLoading,
	providerImageUploader: state?.loader?.providerImageUploader,
	currency: state?.currency
});

const mapDispatch = {
	removeExperience,
	uploadIdentity,
	uploadProfileImage,
	change,
	uploadExperience,
	demoRestriction
}

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(EditPartnerForm)));